// // PaymentDetails.tsx
// import React from "react";
// import { formatDate } from "../../../utils/dateutil";
// import QuoteSummary from "../../payment/QuoteSummary";

// interface PaymentDetailsProps {
//   payments: any[];
//   quote?: any;
//   paymentSummary?: any;
// }
// const formatCurrency = (amount: number) =>
//   amount.toLocaleString("en-IN", {
//     style: "currency",
//     currency: "INR",
//     minimumFractionDigits: 2,
//   });

// const PaymentDetails: React.FC<PaymentDetailsProps> = ({ payments, quote, paymentSummary }) => {
//   if (!payments.length) return null;

//   return (
//     <div className="border rounded bg-gray-50">
//       {quote && (
//         <QuoteSummary
//           quote={quote}
//           paymentSummary={paymentSummary}
//           showPayments={true}
//         />
//       )}
//       <div className="px-4 py-3 bg-gray-200 font-semibold">
//         Payment Transactions
//       </div>

//       <div className="p-4">
//         <table className="w-full border text-sm">
//           <thead>
//             <tr className="bg-gray-100">
//               <th className="border px-2 py-1">Date</th>
//               <th className="border px-2 py-1">Order ID</th>
//               <th className="border px-2 py-1">Transaction ID</th>
//               <th className="border px-2 py-1">Amount</th>
//               <th className="border px-2 py-1">Status</th>
//             </tr>
//           </thead>

//           <tbody>
//             {payments.map((p: any) => (
//               <tr key={p.id}>
//                 <td className="border px-1 py-1">
//                   {formatDate(p.date) ?? "—"}
//                 </td>
//                 <td className="border px-1 py-1">{p.order_id ?? "—"}</td>
//                 <td className="border px-2 py-1">
//                   {p.gateway ?? "—"} - {p.transaction_id ?? "—"}
//                 </td>
//                 <td className="border text-right px-1 py-1">
//                   {`${formatCurrency(p.amount ?? 0)} ${p.currency}`}
//                 </td>
//                 <td className="border text-center px-1 py-1">
//                   {p.status ?? "—"}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default PaymentDetails;

// PaymentDetails.tsx
import React from "react";
import { formatDate } from "../../../utils/dateutil";
import QuoteSummary from "../../payment/QuoteSummary";

interface PaymentDetailsProps {
  payments: any[];
  quote?: any;
  paymentSummary?: any;
}

const formatCurrency = (amount: number) =>
  amount.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  });

const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  payments,
  quote,
  paymentSummary,
}) => {
  // console.log("QUOTE in PaymentDetails:", quote);
  return (
    <div className="border rounded bg-gray-50">
      

      {/* ✅ Show table only if payments exist */}
      {payments?.length > 0 && (
        <>
          <div className="px-4 py-3 bg-gray-200 font-semibold">
            Payment Transactions
          </div>

          <div className="p-4">
            <table className="w-full border text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border px-2 py-1">Date</th>
                  <th className="border px-2 py-1">Order ID</th>
                  <th className="border px-2 py-1">Transaction ID</th>
                  <th className="border px-2 py-1">Amount</th>
                  <th className="border px-2 py-1">Status</th>
                </tr>
              </thead>

              <tbody>
                {payments.map((p: any) => (
                  <tr key={p.id}>
                    <td className="border px-1 py-1">
                      {formatDate(p.date) ?? "—"}
                    </td>
                    <td className="border px-1 py-1">
                      {p.order_id ?? "—"}
                    </td>
                    <td className="border px-2 py-1">
                      {p.gateway ?? "—"} - {p.transaction_id ?? "—"}
                    </td>
                    <td className="border text-right px-1 py-1">
                      {`${formatCurrency(p.amount ?? 0)} ${p.currency}`}
                    </td>
                    <td className="border text-center px-1 py-1">
                      {p.status ?? "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {/* ✅ Optional empty state */}
      {(!payments || payments.length === 0) && (
        <div className="p-4 text-sm text-gray-500">
          No payment transactions yet.
        </div>
      )}
      {/* ✅ Quote always visible if present */}
      {quote && (
        <QuoteSummary
          quote={quote}
          showPayments={true}
        />
      )}

    </div>
  );
};

export default PaymentDetails;